import React from 'react';
import ListConfigurations from '../../components/ListConfigurations';
export default function Configurations() {
  return <ListConfigurations />;
}
